import { Printer } from "react-feather";
import { Card, CardBody, CardHeader } from "reactstrap";
import { EmptyTaskClassProp } from "../../Type/TaskType";
import { H4 } from "../../AbstractElements";
import { Href, Print } from "../../Constant";

const EmptyTaskClass = ({ title }: EmptyTaskClassProp) => {
  return (
    <Card className="mb-0">
      <CardHeader className="d-flex">
        <H4 className="mb-0">{title}</H4>
        <a href={Href}>
          <Printer className="me-2" />{Print}</a>
      </CardHeader>
      <CardBody>
        <div className="details-bookmark text-center">
          <div className="no-favourite">
            <span>No Task Due Today</span>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
export default EmptyTaskClass;
